/** IntelligenceDashboardRoute — skin-aware switcher for /intelligence. */
import { useUISkin } from "@/data/UISkinContext";
import IntelligenceDashboard from "./IntelligenceDashboard";
import IntelligenceDashboardCockpit from "./IntelligenceDashboardCockpit";

export default function IntelligenceDashboardRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <IntelligenceDashboardCockpit />;
  return <IntelligenceDashboard />;
}
